<template>
    <!-- 详情模块 -->
    <div class="form-wrapper">
        <div class="ft-box">
            <div class="ft-title aFlex">
                <Icon class="ft-title-mark" type="md-bookmark" />
                <span>工人工资查询</span>
            </div>
            <ul class="ft-form-wrapper">
                <li class="ft-form-item">
                    <div class="ft-th">项目名称</div>
                    <div class="ft-td ft-bold">{{formData.projectName}}</div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">项目所在地</div>
                    <div class="ft-td">{{formData.areaName}}</div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">所属企业</div>
                    <div class="ft-td">{{formData.corpName}}</div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">班组名称</div>
                    <div class="ft-td">{{formData.teamName}}</div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">人员姓名</div>
                    <div class="ft-td">{{formData.workerName}}</div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">证件类型</div>
                    <div class="ft-td">{{formData.idCardType}}</div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">证件号码</div>
                    <div class="ft-td">{{formData.idCardNumber}}</div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">性别</div>
                    <div class="ft-td">{{formData.gender}}</div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">年龄</div>
                    <div class="ft-td">{{formData.age}}</div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">联系电话</div>
                    <div class="ft-td">{{formData.cellPhone}}</div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">人员类型</div>
                    <div class="ft-td">{{formData.workTypeName}}</div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">岗位类型</div>
                    <div class="ft-td">{{formData.manageTypeName}}</div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">工资月份</div>
                    <div class="ft-td">{{formData.payMonth}}</div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">出勤天数</div>
                    <div class="ft-td">{{formData.days}}</div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">总工时</div>
                    <div class="ft-td">{{formData.workHours}}</div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">应发金额</div>
                    <div class="ft-td">{{formData.totalPayAmount}}</div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">实发金额</div>
                    <div class="ft-td">{{formData.actualAmount}}</div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">是否补发</div>
                    <div class="ft-td">{{formData.isBackPay}}</div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">发放日期</div>
                    <div class="ft-td">{{formData.balanceDate}}</div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">补发月份</div>
                    <div class="ft-td">{{formData.backPayMonth}}</div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">工人工资卡号</div>
                    <div class="ft-td">{{formData.payRollBankCardNumber}}</div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">工人工资卡开户行名称</div>
                    <div class="ft-td">{{formData.payRollBankName}}</div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">工资代发银行卡号</div>
                    <div class="ft-td">{{formData.payBankCardNumber}}</div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">工资代发银行名称</div>
                    <div class="ft-td">{{formData.payBankName}}</div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">第三方工资单编号</div>
                    <div class="ft-td">{{formData.thirdPayRollCode}}</div>
                </li>
            </ul>
        </div>
    </div>
</template>
<style scoped>

</style>
<script>
    import {mapState} from 'vuex';
    export default {
        components: {

        },
        data(){
            return {
                formData:{ },
            };
        },
        computed:{
            ...mapState(['dict']),
        },
        created(){
            this.formData= this.$route.query.row;
            // this.getPageData();
        },
        mounted(){

        },
        watch: {

        },
        methods: {
            /*取消返回*/
            handleCancel() {
                this.$router.go(-1);
            },
            /*获取页面信息*/
            getPageData(){
                // this.axios({
                //     method: 'get',
                //     url:'/corp/detail',
                //     params:{
                //         corpId:this.corpId,
                //     }
                // }).then((response)=>{
                //     if(response.data.success){
                //         this.formData=response.data.data;
                //     }
                // });
            },
        }
    };
</script>
